<template>
  <div class="gallery-container">
    <div class="gallery-header">
      <div class="logo">
        <span class="name">Dendoink</span>
        <span class="text">Photography</span>
      </div>
    </div>
    <div class="gallery-photo-container">
      <div class="photo-list">
        <div
          class="single-photo-parent"
          v-for="(item, index) in firstColumnPhotos"
          :key="index"
        >
          <img :src="item.url" :alt="item.description" class="img-responsive" />
          <div class="photo-info">
            <span v-for="(tag, index) in item.tags" :key="`${tag}-${index}`">{{
              tag
            }}</span>
          </div>
        </div>
      </div>
      <div class="photo-list">
        <div
          class="single-photo-parent"
          v-for="(item, index) in secondColumnPhotos"
          :key="index"
        >
          <img :src="item.url" :alt="item.description" class="img-responsive" />
          <div class="photo-info">
            <span v-for="(tag, index) in item.tags" :key="`${tag}-${index}`">{{
              tag
            }}</span>
          </div>
        </div>
      </div>
      <div class="photo-list">
        <div
          class="single-photo-parent"
          v-for="(item, index) in thirdColumnPhotos"
          :key="index"
        >
          <img :src="item.url" :alt="item.description" class="img-responsive" />
          <div class="photo-info">
            <span
              class="tags"
              v-for="(tag, index) in item.tags"
              :key="`${tag}-${index}`"
              >{{ tag }}</span
            >
          </div>
        </div>
      </div>
      <div class="photo-list">
        <div
          class="single-photo-parent"
          v-for="(item, index) in fourthColumnPhotos"
          :key="index"
        >
          <img
            v-if="item"
            :src="item.url"
            :alt="item.description"
            class="img-responsive"
          />
          <div class="photo-info">
            <span
              class="tags"
              v-for="(tag, index) in item.tags"
              :key="`${tag}-${index}`"
              >{{ tag }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { photoData } from "../utils/photoData";
export default {
  // 主页
  name: "Gallery",
  props: {},
  data() {
    return {
      firstColumnPhotos: [],
      secondColumnPhotos: [],
      thirdColumnPhotos: [],
      fourthColumnPhotos: [],
    };
  },
  computed: {},
  methods: {
    handlePostLink: function (index, dir = "post") {
      window.localStorage.setItem(
        "currentPosts",
        JSON.stringify(this.currentPosts)
      );
      let postName = this.currentPosts[index].name;
      this.$router.push(`/${dir}/${postName}`);
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format("MMMM Do YYYY");
    },
    daysAgo: function (date) {
      let days = new Date() - new Date(date);
      return parseInt(days / (1000 * 60 * 60 * 24));
    },
  },
  created() {
    if (photoData) {
      console.log("photoData: ", photoData);
      debugger;
      for (let x = 0; x < photoData.length; x += 4) {
        if (photoData[x]) {
          this.firstColumnPhotos.push(photoData[x]);
        }
        if (photoData[x + 1]) {
          this.secondColumnPhotos.push(photoData[x + 1]);
        }
        if (photoData[x + 2]) {
          this.thirdColumnPhotos.push(photoData[x + 2]);
        }
        if (photoData[x + 2]) {
          this.fourthColumnPhotos.push(photoData[x + 3]);
        }
      }
    }
  },
};
</script>

<style scoped>
.gallery-container {
  margin-top: 3rem;
  padding: 2rem 3rem;
}
.gallery-header {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}
.gallery-header .logo {
  color: #000000;
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  opacity: 0.8;
}
.gallery-photo-container {
  display: flex;
}
.gallery-header .logo .name {
  display: block;
  font-weight: 400;
  text-transform: uppercase;
  font-size: 1.2rem;
  letter-spacing: 2px;
}
.gallery-header .logo .text {
  display: block;
  text-transform: uppercase;
  font-size: 0.8rem;
  letter-spacing: 8.6px;
  opacity: 0.5;
}
.photo-list .single-photo-parent {
  position: relative;
  display: inline-block;
  height: fit-content;
  transition: all 0.2s ease-in-out;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
  margin-right: 1rem;
  margin-bottom: 1rem;
}
.single-photo-parent img {
  height: auto;
  max-width: 400px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border-top-right-radius: calc(0.25rem - 1px);
  border-top-left-radius: calc(0.25rem - 1px);
}

.single-photo-parent:hover {
  -webkit-box-shadow: 0 18px 32px -18px #000;
  box-shadow: 0 18px 32px -18px #000;
  -webkit-transform: translateY(-6px);
  transform: translateY(-6px);
}
.single-photo-parent .photo-info {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
  display: flex;
  opacity: 0;
  justify-content: center;
  color: #ffffff;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.34) 0,
    rgba(0, 0, 0, 0.338) 3.5%,
    rgba(0, 0, 0, 0.324) 7%,
    rgba(0, 0, 0, 0.306) 10.35%,
    rgba(0, 0, 0, 0.285) 13.85%,
    rgba(0, 0, 0, 0.262) 17.35%,
    rgba(0, 0, 0, 0.237) 20.85%,
    rgba(0, 0, 0, 0.213) 24.35%,
    rgba(0, 0, 0, 0.188) 27.85%,
    rgba(0, 0, 0, 0.165) 31.35%,
    rgba(0, 0, 0, 0.144) 34.85%,
    rgba(0, 0, 0, 0.126) 38.35%,
    rgba(0, 0, 0, 0.112) 41.85%,
    rgba(0, 0, 0, 0.103) 45.35%,
    rgba(0, 0, 0, 0.1) 48.85%,
    rgba(0, 0, 0, 0.103) 52.35%,
    rgba(0, 0, 0, 0.112) 55.85%,
    rgba(0, 0, 0, 0.126) 59.35%,
    rgba(0, 0, 0, 0.144) 62.85%,
    rgba(0, 0, 0, 0.165) 66.35%,
    rgba(0, 0, 0, 0.188) 69.85%,
    rgba(0, 0, 0, 0.213) 73.35%,
    rgba(0, 0, 0, 0.237) 76.85%,
    rgba(0, 0, 0, 0.262) 80.35%,
    rgba(0, 0, 0, 0.285) 83.85%,
    rgba(0, 0, 0, 0.306) 87.35%,
    rgba(0, 0, 0, 0.324) 90.85%,
    rgba(0, 0, 0, 0.338) 94.35%,
    rgba(0, 0, 0, 0.347) 97.85%,
    rgba(0, 0, 0, 0.35)
  );
}

.single-photo-parent:hover .photo-info {
  display: flex;
  opacity: 1;
  cursor: pointer;
}
.photo-info span {
  text-transform: uppercase;
  transition: all 0.2s ease-in-out;
  font-size: 0.5rem;
  margin-top: 8px;
  margin-right: 4px;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Gallery.vue